<script setup>
// import { ref } from 'vue';
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Block Info</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Block Id</label>
                            <input class="form-control" v-model="model.block.blockid" id="input_block_name" type="text" placeholder="A01" disabled />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Block Nama</label>
                            <input class="form-control" v-model="model.block.blockname" id="input_block_name" type="text" placeholder="ACJ PL" />
                        </div>
                        <!-- <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Relong</label>
                            <input class="form-control" v-model="model.block.relong" id="input_relong" type="number" placeholder="1.9999" />
                        </div> -->
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Quantity (PK)</label>
                            <input class="form-control" v-model="model.block.quantity" id="input_quantity" type="number" placeholder="100" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Agreement</label>
                            <argon-input type="text" id="input_remark" v-model="model.block.agreement"  placeholder="Agreement...." />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Umur</label>
                            <input type="number" id="input_age" v-model="model.block.age" class="form-control" >
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Next Potong Date</label>
                            <input class="form-control" v-model="model.block.nextdate" id="input_nextdate" type="date" />
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Lokasi</label>
                            <argon-input type="text" v-model="model.block.address" id="input_address" placeholder="213 Padng Lembu, 08330 Gurun Kedah" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.block.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="updateBlock" style="float: right;" id="btn_update_block">Update</button>
                        </div>
                    </div>
                    <h6>Payment Info</h6>
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Term</label>
                            <select class="form-control" v-model="model.block.term">
                                <option value="0">Free of Charge (FOC)</option>
                                <option value="1">Monthly</option>
                                <option value="2">Market Prices</option>
                                <option value="3">Share Profit (%)</option>
                                <option value="4">Share Net Profit (%)</option>
                            </select>
                        </div>
                        <div class="col-md-2" v-show="model.block.term == 1">
                            <label for="example-text-input" class="form-control-label text-danger">Month <i class="fas fa-info-circle" title="bayar berapa bulan"></i></label>
                            <input class="form-control" v-model="model.block.month" id="input_month" type="number" placeholder="80.00" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term == 1">
                            <label for="example-text-input" class="form-control-label text-danger">Total Amount</label>
                            <input class="form-control" v-model="model.block.amount" id="input_amount" type="number" placeholder="80.00" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term == 4 || model.block.term == 3">
                            <label for="example-text-input" class="form-control-label text-danger " >Percent (Owner) <i class="fas fa-info-circle" title="Kalau owner 30%, record 0.3"></i></label>
                            <input class="form-control" v-model="model.block.percentowner" id="input_percent_owner" type="number" placeholder="80.00" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term == 2" >
                            <label for="example-text-input" class="form-control-label text-danger " >Market Price (RM) <i class="fas fa-info-circle" title="E.g (700-800 RM 4500),(800-900 RM 5000)"></i></label>
                            <input class="form-control" v-model="model.block.marketprice" id="input_marketprice" type="number" placeholder="80.00" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term != 0">
                            <label for="example-text-input" class="form-control-label">Bank</label>
                            <input class="form-control" v-model="model.block.bank" id="input_bank" type="text" placeholder="Publick Bank" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term != 0">
                            <label for="example-text-input" class="form-control-label">Bank Acc</label>
                            <input class="form-control" v-model="model.block.bankacc" id="input_bankacc" type="number" placeholder="99999999999" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Name</label>
                            <input class="form-control" v-model="model.block.name" id="input_name" type="text" placeholder="Ang Wei Ze" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Start Date</label>
                            <input class="form-control" v-model="model.block.startdate" id="input_startdate" type="date" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">End Date</label>
                            <input class="form-control" v-model="model.block.enddate" id="input_enddate" type="date" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Payment Info Remark</label>
                            <input class="form-control" v-model="model.block.paymentremark" id="input_name" type="text" placeholder="Ang Wei Ze" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="updateBlockPayment" style="float: right;" id="btn_update_blockpayment">Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'blockCreate',
  data(){
    return {
        componentKey: 0,
    //   errorList: '',
      model:{
        block:{
            blockid:'',
            blockname:'',
            address:'',
            remark:'',
            relong:'',
            quantity:'',
            nextdate:'',
            age:'',
            term:'',
            amount:'',
            bank:'',
            bankacc:'',
            name:'',
            agreement:'',
            marketprice:null,
            percentowner:null,
            month:null,
            paymentremark:null,
            startdate: null,
            enddate:null
        },
        

      }
    }
  },
  mounted(){
    this.model.block.blockid = this.$route.params.id;
    this.getBlockDetailByID();
  },
  methods: {
    updateBlock(){
        // var mythis = this;
        axios.post('block/updateBlock',this.model.block)
            .then(res => {
                alert(res.data.message);
                
            }).catch(function (error){
                console.log('Error',error.message);
            });
    },
    updateBlockPayment(){
        // var mythis = this;
        axios.post('block/updateBlockPayment',this.model.block)
            .then(res => {
                alert(res.data.message);
            }).catch(function (error){
                console.log('Error',error.message);
            });
    },
    getBlockDetailByID(){
        // var mythis = this;
        axios.get('block/getBlockDetailByID/' + this.$route.params.id)
            .then(res => {
                this.model.block = res.data.block[0];
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>